import _ from "lodash";
import React from "react";
import cn from "classnames";
import {
  generateElementKey,
  cleanElementName,
  md,
  stringifyClassNames,
  generateRootId,
} from "../../lib/helpers";
import { ELEMENT_KEYS } from "../../lib/constants";

const Card = ({
  page,
  postRef,
  data,
  selectedElement,
  _updateSelectedElement,
  localProperties,
  globalProperties,
  layoutConfig,
  postVariant,
  cardIdx,
  bgFiles,
}) => {
  const { layout, className = "", pagination } = page;
  const refId = generateRootId(cardIdx);
  const bgFile = bgFiles[0]?.url || "";
  const cardRootClasses = cn(
    ELEMENT_KEYS.RAW_ROOT_EDITOR,
    className,
    ...Object.values(_.get(globalProperties, ELEMENT_KEYS.RAW_ROOT_EDITOR, {})),
  );
  const cardRootStyles = {
    backgroundImage: bgFile ? `url('${bgFile}')` : undefined,
  };
  const visibleLayoutElements = layout.filter(({ key: element }) =>
    _.get(layoutConfig, [element, "visible"], true),
  );

  const getValue = (element) => {
    let value = _.get(data, element, "");

    if (element === "brand") {
      value = value.replace(/\./g, "&#46;"); // replace '.' with html entity code for dot, fixes conversion to hyperlink
    }

    return value;
  };

  return (
    <div
      data-page-id={cardIdx}
      ref={(el) => (postRef.current[refId] = el)}
      className={cardRootClasses}
      style={cardRootStyles}
    >
      {visibleLayoutElements.map(({ key: element, type }) => {
        const fullKey = generateElementKey(cardIdx, element, null);

        const value = getValue(element);

        const mergedProperties = {
          ..._.get(globalProperties, cleanElementName(element), {}),
          ..._.get(localProperties, fullKey, {}),
        };

        const classNames = cn(
          "element",
          element,
          ...Object.values(mergedProperties),
          {
            outlined: selectedElement === fullKey,
          },
        );

        if (type === "media") {
          const files = data.files.filter((file) =>
            postVariant === "default" ? true : file.pos === cardIdx,
          );

          return files.length
            ? files.map(({ url }, index) => (
                <div
                  className={classNames}
                  key={fullKey}
                  onClick={() => _updateSelectedElement(fullKey)}
                >
                  <img
                    className="w-full"
                    key={index}
                    src={url}
                    alt={`Selected file ${index + 1}`}
                  />
                </div>
              ))
            : null;
        }

        if (!value) return null;
        return (
          <div
            key={fullKey}
            onClick={() => _updateSelectedElement(fullKey)}
            className={classNames}
            dangerouslySetInnerHTML={{
              __html: md.render(value),
            }}
          />
        );
      })}

      {pagination && (
        <div
          className={stringifyClassNames(
            globalProperties["pagination"],
            "pagination",
          )}
        >
          {pagination}
        </div>
      )}
    </div>
  );
};

export default Card;
